import type { RouteObject } from "react-router-dom";

/*
  Getting started in the 2026-11-03 design (stage 4.6): an interactive presentation with a chat to ask anytime and a FAQ. The view
  loads when it is first opened. Who may open the address is in `app/screens.ts`; it is not repeated here. The older address
  (`/onboarding`) opens this view (`MOVED_SCREENS` in `app/screens.ts`).
*/

export const routes: RouteObject[] = [
  { path: "/getting-started", lazy: async () => ({ Component: (await import("./GettingStartedView")).GettingStartedView }) },
];
